import React, { SVGProps } from 'react';

const Wallet: React.FC<SVGProps<SVGSVGElement>> = (props) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        fill='none'
        viewBox='0 0 16 16'
        width={16}
        height={16}
        {...props}
    >
        <path
            stroke='currentColor'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={1.5}
            d='M3 4.111A1.11 1.11 0 0 1 4.11 3h5c.517 0 .775 0 .987.057a1.67 1.67 0 0 1 1.178 1.178c.057.212.057.47.057.987H4.111A1.11 1.11 0 0 1 3 4.112m0 0v5.556c0 1.571 0 2.357.488 2.845S4.762 13 6.333 13h3.334c1.57 0 2.357 0 2.845-.488S13 11.238 13 9.667V8.556c0-1.572 0-2.357-.488-2.846-.489-.488-1.274-.488-2.845-.488H5.222M13 8h-1.111c-.258 0-.388 0-.494.028a.83.83 0 0 0-.589.59c-.028.106-.028.235-.028.493s0 .388.028.494a.83.83 0 0 0 .59.589c.105.028.234.028.493.028h1.11'
        />
    </svg>
);

export default Wallet;
